import React from 'react';

export interface SignoDolarIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const SignoDolarIcon: React.FC<SignoDolarIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12.333 1v22m5-18h-7.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 1 1 0 7h-8.5"/>
    </svg>
  );
};

export default SignoDolarIcon;
